import { request } from "@/utils/request";
// 手动发送微信通知
export function wxSendAPi(data) {
  return request({
    url: `/public/wechatNotify/handSend/send`,
    method: "POST",
    data,
    isEncrypt: false,
    isDecrypt: false,
  });
}